// Libraries
import React from 'react'
import { useDropzone } from 'react-dropzone'
import { Grid, Typography } from '@material-ui/core'

// Styles
import useDropzoneStyles from './styles'

// Images
import IMG_UPLOAD from 'images/components/bg-upload-files-1.svg'

function Dropzone({
   acceptCallback = () => {},
   rejectCallback = () => {},
   multiple = false,
   accept = '.csv',
   closePopover,
   isEditable = false,
   title = '',
   description = ''
}) {
   const styles = useDropzoneStyles()

   const { getRootProps, getInputProps, isDragActive } = useDropzone({
      accept,
      multiple,
      onDropAccepted,
      onDropRejected
   })

   function onDropAccepted(arrayOfFiles) {
      acceptCallback(arrayOfFiles)
      closePopover()
   }

   function onDropRejected() {
      rejectCallback(accept)
   }

   return (
      <>
         <Grid className={styles.container}>
            <div className={styles.dragZone} {...getRootProps()}>
               <div className={styles.imgContainer}>
                  <img alt="Cargar Archivo" src={IMG_UPLOAD} />
               </div>
               <input className={styles.dragZoneContent} {...getInputProps()} />
               {isDragActive ? (
                  <Typography>
                     {isEditable
                        ? title
                        : `Arrastre y suelte el archivo ${accept} aquí.`}
                  </Typography>
               ) : (
                  <Typography>
                     {isEditable
                        ? title
                        : `Arrastre y suelte el archivo ${accept} aquí, o haga click para seleccionarlo`}
                  </Typography>
               )}
               <div className={styles.description}>
                  <Typography>{isEditable ? description : ''}</Typography>
               </div>
            </div>
         </Grid>
      </>
   )
}

export default Dropzone
